var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUsdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 25,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23_571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.875 19.5C15.1217 19.5 19.375 15.2467 19.375 10C19.375 4.75329 15.1217 0.5 9.875 0.5C4.62829 0.5 0.375 4.75329 0.375 10C0.375 15.2467 4.62829 19.5 9.875 19.5Z",
    fill: "#26A17B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0162 10.8211V10.82C10.9509 10.8247 10.6142 10.8449 9.86312 10.8449C9.26344 10.8449 8.84128 10.8271 8.69284 10.82V10.8217C6.38434 10.7202 4.66128 10.3182 4.66128 9.8373C4.66128 9.35695 6.38434 8.95499 8.69284 8.85167V10.4215C8.84365 10.4322 9.2759 10.4578 9.87322 10.4578C10.5899 10.4578 10.9491 10.4281 11.0162 10.4221V8.85286C13.3199 8.95558 15.0388 9.35755 15.0388 9.8373C15.0388 10.3182 13.3199 10.719 11.0162 10.8211ZM11.0162 8.68958V7.28477H14.2307V5.14252H5.47828V7.28477H8.69284V8.68899C6.08034 8.80892 4.11562 9.32667 4.11562 9.94655C4.11562 10.5664 6.08034 11.0836 8.69284 11.2041V15.7059H11.0162V11.2029C13.6245 11.083 15.5845 10.5658 15.5845 9.94655C15.5845 9.32727 13.6245 8.81011 11.0162 8.68958Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_571"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white",
    transform: "translate(0.375 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUsdt);
export default __webpack_public_path__ + "static/media/icon-usdt.b4519296ed8d683226a11f3c30f47e09.svg";
export { ForwardRef as ReactComponent };